<template>
  <div>
    <div class="d-flex justify-content-center mt-4 mb-2 mx-5">
      {{ name }}
    </div>

    <div class="mt-4 mb-2 mx-5" v-html="formatContract(replaced_text)"></div>

    <div class="d-flex justify-content-end">
      <v-btn class="aligin-ritgh print-btn" @click="handleToPrint()">
        <i class="fas fa-print mr-1"></i>
        Imprimir Contrato
      </v-btn>
    </div>

    <!-- HTML Imprimir -->
    <div id="print-section" class="print-section">
      <div class="print-contract-title">
        {{ name }}
      </div>

      <div class="print-contract-content">
        <div v-html="replaced_text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

export default {
  name: "ContractPrintView",

  data() {
    return {
      loading: false,

      contract_id: null,

      name: "",

      replaced_text: "",
    };
  },

  async created() {
    if (this.$route.params.contract_id) {
      this.contract_id = this.$route.params.contract_id;
    }

    await this.getContract();
  },

  methods: {
    async getContract() {
      try {
        this.loading = true;

        const { contract_id } = this;

        let params = { contract_id };

        const response = await api.get("/contract", {
          params,
        });

        const { error, contract, replaced_text } = response.data;

        if (!error) {
          this.name = contract.name;

          this.replaced_text = replaced_text;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    formatContract(text) {
      if (!text) {
        return "";
      }

      return text.replace(/\n/g, "<br>");
    },

    handleToPrint: () => window.print(),
  },
};
</script>

<style scoped>
#print-section {
  display: none;
}

@media print {
  #print-section,
  #print-section * {
    visibility: visible !important;
  }

  #print-section {
    display: block !important;
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    min-height: 100vh;
    background: white !important;
    padding: 0;
    margin: 0;
    z-index: 9999;
  }

  @page {
    margin: 0 !important;
  }

  .print-contract-title {
    margin: 0 auto;
    max-width: 900px;
    width: 90vw;
    text-align: center;
    font-weight: bold;
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .print-contract-content {
    white-space: pre-line;
    margin: 0 auto;
    max-width: 900px;
    width: 90vw;
    font-size: 1.1em;
    line-height: 1.6;
    text-align: left;
    word-break: break-word;
  }
}

.print-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3) !important;
  transition: all 0.3s ease !important;
}

.print-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4) !important;
}

@media print {
  .print-btn {
    display: none !important;
  }
}
</style>